import Booking from '../screens/Booking'
import BookingDetailsResults from '../screens/BookingDetailsResults'
import BookingHotelSearchResult from '../screens/BookingHotelSearchResult'
import BookingStepper from '../screens/BookingStepper'
import PaymentError from '../screens/PaymentError'
import PaymentSucces from '../screens/PaymentSucces'
import Voucher from '../screens/voucher'
import { allRoles, RouteWithAccessType } from './types'

export const RoleAccessManagement: RouteWithAccessType[] = [
  {
    route: '/',
    exact: true,
    rolesListWithReadAccess: allRoles,
    rolesListWithWriteAccess: allRoles,
    component: Booking
  },
  {
    route: '/hotel',
    exact: false,
    rolesListWithReadAccess: allRoles,
    rolesListWithWriteAccess: allRoles,
    component: BookingHotelSearchResult
  },
  {
    route: '/bookstepper/:page',
    exact: true,
    rolesListWithReadAccess: allRoles,
    rolesListWithWriteAccess: allRoles,
    component: BookingStepper
  },
  {
    route: '/payment-success/:reservationNumber/:hash',
    exact: true,
    rolesListWithReadAccess: allRoles,
    rolesListWithWriteAccess: allRoles,
    component: PaymentSucces
  },
  {
    route: '/payment-error/:reservationNumber/:hash',
    exact: true,
    rolesListWithReadAccess: allRoles,
    rolesListWithWriteAccess: allRoles,
    component: PaymentError
  },
  {
    route: '/booking-details/:reservationNumber/:paymentNumber',
    exact: true,
    rolesListWithReadAccess: allRoles,
    rolesListWithWriteAccess: allRoles,
    component: BookingDetailsResults
  },
  {
    route: '/vouherPdf/:hash',
    exact: true,
    rolesListWithReadAccess: allRoles,
    rolesListWithWriteAccess: allRoles,
    component: Voucher
  }
]
